import { SignInOptions, signIn as _signIn } from 'next-auth/react';

export async function signIn(
  options?: SignInOptions | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  authorizationParams?: any,
) {
  return await _signIn('portal-credentials', options, authorizationParams);
}
